var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn tool-btn",on:{"click":function($event){return _vm.$emit('onClick', _vm.type)}}},[_c('img',{attrs:{"src":require('@/assets/img/toolbar/' + _vm.type + '.png')}}),_vm._v(_vm._s(_vm.$t("tool." + _vm.type))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }